import { render, staticRenderFns } from "./SignableDocumentModal.vue?vue&type=template&id=156b8840&scoped=true&"
import script from "./SignableDocumentModal.vue?vue&type=script&lang=ts&"
export * from "./SignableDocumentModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156b8840",
  null
  
)

export default component.exports